import { render, staticRenderFns } from "./control3Wordshocksx.vue?vue&type=template&id=ebdbd6e8&scoped=true&"
import script from "./control3Wordshocksx.vue?vue&type=script&lang=js&"
export * from "./control3Wordshocksx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdbd6e8",
  null
  
)

export default component.exports